import React, { FunctionComponent, useState } from "react";
import { IconButton, ListActionButtonProps, Modal, Stack, Text } from "sprint-common-web";

import { EncodeSpecificationType } from "../../context/EncodeSpecificationItem";
import { EncodeSpecificationListingItem, EncodeSpecificationMpeg4ListingItem } from "../EncodeSpecificationListingItem";

export interface EncodeSpecificationInfoDisplayModalProps {
    encodeSpecification?: {
        id: string;
        name: string;
        ffmpegCommand: string;
    };
    isLoading?: boolean;
    isModalOpen: boolean;
    onDismiss(): void;
}

export const EncodeSpecificationInfoDisplayModal: FunctionComponent<EncodeSpecificationInfoDisplayModalProps> = (
    props: EncodeSpecificationInfoDisplayModalProps
) => {
    return (
        <Modal isOpen={props.isModalOpen} headerText={props.encodeSpecification?.name} onDismiss={props.onDismiss}>
            <Stack>
                <Text nowrap={false} isLoading={props.isLoading}>
                    {props.encodeSpecification?.ffmpegCommand}
                </Text>
            </Stack>
        </Modal>
    );
};

export const ShowFfmpegCommandButton: FunctionComponent<ListActionButtonProps<EncodeSpecificationListingItem>> = (
    props: ListActionButtonProps<EncodeSpecificationListingItem>
) => {
    const { disabled, item, id } = props;
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const isButtonDisabled = disabled || !isEncodeSpecMpeg4(item);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const ffmpegCommand = isEncodeSpecMpeg4(item) ? item.details.ffmpegCommand : "";

    return (
        <>
            <IconButton
                key={id}
                iconProps={{ iconName: "Info" }}
                disabled={isButtonDisabled}
                onClick={openModal}
                tooltipContent="Show ffmpeg command"
            />
            <EncodeSpecificationInfoDisplayModal
                onDismiss={closeModal}
                encodeSpecification={{ name: item.name, ffmpegCommand, id: item.id }}
                isModalOpen={isModalOpen}
            />
        </>
    );
};

const isEncodeSpecMpeg4 = (
    encodeSpec: EncodeSpecificationListingItem
): encodeSpec is EncodeSpecificationMpeg4ListingItem => encodeSpec.type === EncodeSpecificationType.MPEG_4;
